import { Flex, useToast } from '@chakra-ui/react'
import { FaSave } from 'react-icons/fa'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { appApi } from '../../../../../../services/appApi'
import { ModalBase } from '../../../../../../components/ModalBase'
import { InputCmp } from '../../../../../../components/InputCmp'
import { useEffect, useState } from 'react'

interface iModalProps {
  isOpen: boolean
  paramId: string
  val: number
  Reload: () => void
  onClose: () => void
}
export const ModalFuncionarios: React.FC<iModalProps> = ({ isOpen, onClose, Reload, paramId, val }) => {
  const [Val, setVal] = useState<number>()
  const toast = useToast()

  function onAtualizarFuncionarios(): void {
    appApi.put(`Pec/${paramId}/AtualizarFuncionarios`, { val: Val })
      .then(() => {
        toast({
          title: 'Número de funcionários atualizados com sucesso',
          status: 'success',
          position: 'top',
          duration: 4000
        })
        Reload()
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    setVal(val)
  }, [val])

  return (
    <ModalBase
      Titulo="Número de funcionários"
      isOpen={isOpen}
      onClose={onClose}
      Width='36rem'
    >
      <Flex padding={'0 1rem 1rem 1rem'} flexDir={'column'}>
        <InputCmp value={Val} OnChange={(e) => setVal(parseInt(e))} type={'number'}/>
      </Flex>
      <Flex padding={'0 1rem 1rem 0'} justifyContent={'end'} gap={'.5rem'}>
        <ButtonCmp VarColor='c5' onClick={onClose}>Voltar</ButtonCmp>
        <ButtonCmp VarColor='Green2' onClick={onAtualizarFuncionarios} leftIcon={<FaSave/>}>Salvar</ButtonCmp>
      </Flex>
    </ModalBase>
  )
}
